import { Paper } from '@mui/material'
import ReceiptsTableHead from './ReceiptsTableHead'
import ReceiptsTableData from './ReceiptsTableData'
import ReceiptDiscussion from '../ReceiptDiscussion/ReceiptDiscussion'
import { useSelector } from 'react-redux'

const tableHeadings = {
    company: 'Company',
    date: 'Date',
    receipt_number: 'Receipt Number',
    receipt_amount: 'Receipt Amount',
    receipt_status: 'Receipt Status',
    fme: 'FME',
    fme_income: 'FME Income',
    policy_fme_income: 'Policy FME Income',
    manual_fme_income: 'Manual FME Income',
    covered: '% Covered',
    account: 'Account',
    brands: 'Brands',
}

const ReceiptsTable = () => {
    const { selectedRow } = useSelector((state: any) => state.receipts);
    return (
        <>
            <Paper sx={{ mb: 1 }}>
                <ReceiptsTableHead />
                <ReceiptsTableData tableHeadings={tableHeadings} />
            </Paper>
            {selectedRow.length > 0 && <ReceiptDiscussion />}
        </>
    )
}

export default ReceiptsTable
